export const RESET_PASSWORD = 'reset_password';
export const RESET_RESPONSE = 'reset_response';

export const SET_IS_AUTHENTICATED = 'set_is_authenticated';

export const SIGN_UP = 'sign_up';
export const SIGN_UP_STATUS = 'sign_up_status';

export const LOGIN_USERNAME = 'login_username';
export const LOGIN_PASSWORD = 'login_password';
export const LOGIN = 'login';
export const LOGIN_STATUS = 'login_status';
export const ACCEPT_TERMS = 'accept_terms';

export const LOGIN_SERVICE_SUCCESS = 'login_service_success';
export const LOGIN_SERVICE_PENDING = 'login_service_pending';
export const LOGIN_SERVICE_ERROR   = 'login_service_error';


export const RESET_FORM_DATA       = 'reset_form_data';
export const RESET_SERVICE_SUCCESS = 'reset_service_success';
export const RESET_SERVICE_PENDING = 'reset_service_pending';
export const RESET_SERVICE_ERROR   = 'reset_service_error';


export const SIGNUP_SERVICE_SUCCESS = 'signup_service_success';
export const SIGNUP_SERVICE_PENDING = 'signup_service_pending';
export const SIGNUP_SERVICE_ERROR   = 'signup_service_error';

/***************change password actions*****************/
export const FORCE_RESET_PASSWORD = 'force_reset_password';
export const UPDATE_CHANGE_PASSWORD_FORM = 'update_change_password_form';
export const CHANGE_PASSWORD_ERROR = 'change_password_error';
export const CHANGE_PASSWORD_PENDING = 'change_password_pending';
export const CHANGE_PASSWORD_SUCCESS = 'change_password_success';
export const SHOW_CHANGE_PASSWORD_DIALOG = 'show_change_password_dialog';
export const HIDE_CHANGE_PASSWORD_DIALOG = 'hide_change_password_dialog';
/***************change password actions*****************/

export const SHOW_SIGNOUT_DIALOG = 'show_signout_dialog';
export const HIDE_SIGNOUT_DIALOG = 'hide_Signout_dialog';
export const DISABLE_FORCE_RESET_PASSWORD = 'disable_force_reset_password';
